import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNeighbor = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.333 17.5V15.833C12.3329 15.2144 12.0868 14.6211 11.6494 14.1836C11.2118 13.746 10.6179 13.5 9.99902 13.5H4.99902C4.3803 13.5001 3.78712 13.7461 3.34961 14.1836C2.9121 14.6211 2.6661 15.2143 2.66602 15.833V17.5C2.66602 18.0523 2.2183 18.5 1.66602 18.5C1.11373 18.5 0.666016 18.0523 0.666016 17.5V15.833C0.666102 14.6839 1.12297 13.5821 1.93555 12.7695C2.74813 11.957 3.84987 11.5001 4.99902 11.5H9.99902C11.1483 11.5 12.2508 11.9569 13.0635 12.7695C13.876 13.5821 14.3329 14.6839 14.333 15.833V17.5C14.333 18.0522 13.8851 18.4998 13.333 18.5C12.7807 18.5 12.333 18.0523 12.333 17.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8311 5.83322C14.8311 5.31637 14.6591 4.81425 14.3428 4.40548C14.0265 3.99669 13.5834 3.70415 13.083 3.57443C12.5485 3.4358 12.2276 2.89026 12.3662 2.35568C12.5049 1.82112 13.0504 1.50029 13.585 1.63888C14.5142 1.87979 15.3374 2.42267 15.9248 3.18185C16.5121 3.94095 16.8311 4.87347 16.8311 5.83322C16.8311 6.79317 16.5123 7.72636 15.9248 8.48556C15.3374 9.24468 14.5141 9.78665 13.585 10.0276C13.0504 10.1662 12.5048 9.84537 12.3662 9.31076C12.2277 8.77619 12.5485 8.23061 13.083 8.09201C13.5834 7.96229 14.0265 7.66975 14.3428 7.26095C14.659 6.85219 14.8311 6.35004 14.8311 5.83322Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.3338 17.4999V15.8339C17.3334 15.317 17.1612 14.8147 16.8445 14.4062C16.5278 13.9976 16.0843 13.7053 15.5838 13.5761C15.0491 13.438 14.7279 12.893 14.866 12.3583C15.0041 11.8236 15.5491 11.5025 16.0838 11.6405C17.0134 11.8806 17.8374 12.4218 18.4256 13.1806C19.0138 13.9394 19.3331 14.8728 19.3338 15.8329V17.4999C19.3338 18.0522 18.8861 18.4999 18.3338 18.4999C17.7815 18.4999 17.3338 18.0522 17.3338 17.4999Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.83301 5.83301C9.83283 4.54449 8.78758 3.5 7.49902 3.5C6.21062 3.50018 5.16619 4.5446 5.16602 5.83301C5.16602 7.12156 6.21051 8.16682 7.49902 8.16699C8.78769 8.16699 9.83301 7.12167 9.83301 5.83301ZM11.833 5.83301C11.833 8.22624 9.89226 10.167 7.49902 10.167C5.10594 10.1668 3.16602 8.22613 3.16602 5.83301C3.16619 3.44003 5.10605 1.50018 7.49902 1.5C9.89215 1.5 11.8328 3.43992 11.833 5.83301Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgNeighbor);
export default ForwardRef;
